var angular = require('angular')
var subYears = require('date-fns/fp/subYears').default
var startOfDay = require('date-fns/fp/startOfDay').default
var parseISO = require('date-fns/fp/parseISO').default
var differenceInYears = require('date-fns/fp/differenceInYears').default
var addYears = require('date-fns/fp/addYears').default
var addMonths = require('date-fns/fp/addMonths').default
var startOfMonth = require('date-fns/fp/startOfMonth').default
require('../../services/app.dataservice')
require('../../services/generator.dataservice')
require('../../services/disbursement.service')

angular.module('AemCspsDisbursementCalculator')
  .component('pp', {
    template: require('./pp.component.tpl.html'),
    controller: PpCtrl,
    controllerAs: 'vm',
    bindings: {}
  })

PpCtrl.$inject = ['appDataservice', 'generatorDataservice', 'disbursementService',
  'userTracking', '$locale', '$location']

function PpCtrl (appDataservice, generatorDataservice, disbursementService,
  userTracking, $locale, $location) {
  var vm = this
  var canceler = null

  vm.$onInit = function () {
    vm.canRender = false
    vm.result = null
    vm.submit = submit
    vm.isResultTotalSavedAmountPerPartes = false
    appDataservice.paramsPromise
      .then(function (res) {
        vm.disclaimerTextPP = res.data.ppParams.disclaimer
        vm.birthDate = {
          min: parseISO('1900-01-01'),
          max: startOfDay(subYears(18)(Date.now())),
          default: parseISO('1970-01-01')
        }
        try {
          vm.birthDate = {
            min: parseISO(res.data.ppParams.birthDate.min),
            max: startOfDay(subYears(res.data.ppParams.birthDate.maxYears)(Date.now())),
            default: parseISO(res.data.ppParams.birthDate.default)
          }
        } catch (e) {}
        vm.birthDate.value = vm.birthDate.default
        vm.calculationAge = {
          min: 0,
          max: 105,
          default: differenceInYears(vm.birthDate.value, startOfDay(Date.now())),
          step: 10
        }
        try {
          vm.calculationAge.min = res.data.ppParams.calculationAge.min
        } catch (e) {}
        try {
          vm.calculationAge.max = res.data.ppParams.calculationAge.max
        } catch (e) {}
        try {
          vm.calculationAge.step = res.data.ppParams.calculationAge.step
        } catch (e) {}
        try {
          if ($locale.id === 'cs') {
            vm.tips = [res.data.ppParams.hintText.cs]
          }
          if ($locale.id === 'en') {
            vm.tips = [res.data.ppParams.hintText.en]
          }
        } catch (e) {}
        vm.calculationAge.value = vm.calculationAge.default
        vm.gender = generatorDataservice.value('gender', res.data.ppParams, { default: 'F' })
        vm.partyContributionSum = generatorDataservice.value('partyContributionSum', res.data.ppParams, {
          min: 0,
          max: 10000000,
          default: 0,
          step: 1000
        })
        vm.employerContributionSum = generatorDataservice.value('employerContributionSum', res.data.ppParams, {
          min: 0,
          max: 10000000,
          default: 0,
          step: 1000
        })
        vm.stateContributionSum = generatorDataservice.value('stateContributionSum', res.data.ppParams, {
          min: 0,
          max: 10000000,
          default: 0,
          step: 1000
        })
        vm.yieldSum = generatorDataservice.value('yieldSum', res.data.ppParams, {
          min: 0,
          max: 10000000,
          default: 0,
          step: 1000
        })
        vm.totalSavedAmount = generatorDataservice.value('totalSavedAmount', res.data.ppParams, {
          min: 1000,
          max: 10000000,
          default: 0,
          step: 1000
        })
        vm.isTotalSavedAmountPerPartes = vm.employerContributionSum.default > 0 || vm.stateContributionSum.default > 0 || vm.yieldSum.default > 0

        if (getParameterByName('totalSavedAmount')) {
          vm.totalSavedAmount.value = parseInt(getParameterByName('totalSavedAmount'))
          vm.isTotalSavedAmountPerPartes = true
        }
        if (getParameterByName('totalPartyContribution')) {
          vm.partyContributionSum.value = parseInt(getParameterByName('totalPartyContribution'))
        }
        if (getParameterByName('totalEmployerContribution')) {
          vm.employerContributionSum.value = parseInt(getParameterByName('totalEmployerContribution'))
        }
        if (getParameterByName('totalStateContribution')) {
          vm.stateContributionSum.value = parseInt(getParameterByName('totalStateContribution'))
        }
        if (getParameterByName('totalExpectedYield')) {
          vm.yieldSum.value = parseInt(getParameterByName('totalExpectedYield'))
        }
        return submit()
      })
      .finally(function () {
        vm.canRender = true
      })
  }

  function submit () {
    if (vm.isTotalSavedAmountPerPartes) {
      vm.totalSavedAmount.value = vm.partyContributionSum.value + vm.employerContributionSum.value + vm.stateContributionSum.value + vm.yieldSum.value
    } else {
      vm.partyContributionSum.value = vm.totalSavedAmount.value
      vm.employerContributionSum.value = 0
      vm.stateContributionSum.value = 0
      vm.yieldSum.value = 0
    }

    if (vm.birthDate.value === null) {
      vm.birthDate.value = vm.birthDate.default
    }

    var calculationDate = startOfMonth(addMonths(1)(addYears(vm.calculationAge.value)(vm.birthDate.value)))

    vm.data = {
      yearOfBirth: vm.birthDate.value.getFullYear(),
      monthOfBirth: vm.birthDate.value.getMonth() + 1,
      dayOfBirth: vm.birthDate.value.getDate(),
      calculationDateYears: calculationDate.getFullYear(),
      calculationDateMonths: calculationDate.getMonth() + 1,
      calculationDateDays: calculationDate.getDate(),
      gender: vm.gender.value,
      totalSavedAmount: vm.totalSavedAmount.value,
      partyContributionSum: vm.partyContributionSum.value,
      employerContributionSum: vm.employerContributionSum.value,
      stateContributionSum: vm.stateContributionSum.value,
      yieldSum: vm.yieldSum.value
    }

    if (canceler) {
      canceler.resolve()
    }
    userTracking.onRequest(vm.data)
    var request = disbursementService.pp(vm.data)
    canceler = request.canceler
    return request.promise
      .then(function (res) {
        userTracking.onResponse(res.data)
        vm.result = res.data
      })
      .catch(function (err) {
        if (~err.status) {
          userTracking.onResponse(null, 'failed')
          appDataservice.error = err
        }
      })
  }

  function getParameterByName (name) {
    var searchObject = $location.search()
    return searchObject[name]
  }
}
